import * as React from 'react'
import { SVGProps } from 'react'

const SvgLockIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M12.667 5.616v-.95a4.667 4.667 0 1 0-9.334 0v.95a3.333 3.333 0 0 0-2 3.05v4A3.337 3.337 0 0 0 4.667 16h6.666a3.337 3.337 0 0 0 3.334-3.333v-4a3.333 3.333 0 0 0-2-3.051Zm-4 5.717a.667.667 0 1 1-1.334 0V10a.667.667 0 1 1 1.334 0v1.333Zm2.666-6H4.667v-.666a3.333 3.333 0 0 1 6.666 0v.666Z' />
  </svg>
)

export default SvgLockIcon
